import React, {Suspense, useEffect, useRef} from 'react';
import {ToastContainer} from 'react-toastify';
import {HelmetProvider} from 'react-helmet-async';
import {App as CapacitorApp} from '@capacitor/app';

import {Capacitor, PluginListenerHandle} from '@capacitor/core';

import {useNavigate} from 'react-router-dom';

import {MonitorPickerProvider} from 'entities/monitor';
import {NewsletterPopup} from 'entities/user';

import SpinnerWithOverlay from 'shared/ui/SpinnerWithOverlay/SpinnerWithOverlay';

import {httpMonitorPicker} from 'features/http';

import {UserFetchMe} from './ui/UserFetchMe/UserFetchMe';
import Router from './Router';
import {menuItems, menuGroups} from './menu';
import {useMetricateHit} from '../shared/lib/hooks/useMetricateHit';
import ScrollToTop from './ui/ScrollToTop/ScrollToTop';
import {NavigationProvider} from '../widgets/layout';

const navigationConfig = {menuItems, menuGroups};

export default function App() {
    useMetricateHit(94769067);
    const navigation = useNavigate();

    const backButtonRef = useRef<PluginListenerHandle | undefined>(undefined);

    useEffect(() => {
        const setBackButtonListener = async() => {
            backButtonRef.current = await CapacitorApp.addListener('backButton', () => {
                navigation(-1);
            });
        };

        if (Capacitor.isNativePlatform()) {
            setBackButtonListener();
        }
        return () => {
            if (backButtonRef.current) backButtonRef.current.remove();
        };
    }, [navigation]);

    return (
        <HelmetProvider>
            <Suspense fallback={<SpinnerWithOverlay/>}>
                <UserFetchMe />
                <MonitorPickerProvider value={httpMonitorPicker}>
                    <NavigationProvider value={navigationConfig}>
                        <Router />
                    </NavigationProvider>
                </MonitorPickerProvider>
                <ScrollToTop />
                <NewsletterPopup />
                <ToastContainer/>
            </Suspense>
        </HelmetProvider>
    );
}
